export type PaginationMeta = {
  total: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  limit: number;

};

export type PaginatedResponse<T> = {
  data: T[];
  meta: PaginationMeta;
};


export enum LabelType {
  MAILBOX = 'mailbox',
  DNS = 'dns',
  POSTMASTER = 'postmaster',
  TEMPLATE = 'template',
  SENDER_PROFILE = 'sender_profile',
}

export enum AuthProvider {
  SMTP = 'smtp',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  AWS_API = 'aws_api',
  AWS_SMTP = 'aws_smtp',
  SENDGRID_SMTP = 'sendgrid',
  SENDGRID_API = 'sendgrid',
  KLAVIYO = 'klaviyo',
  MAILCHIMP = 'mailchimp',
  SHOPIFY_EMAIL = 'shopify_email',
  ACTIVECAMPAIGN = 'activecampaign',
  BREVO = 'brevo',
  CONVERTKIT = 'convertkit',
  HUBSPOT = 'hubspot',
  DRIP = 'drip',
  GETRESPONSE = 'getresponse',
  MOOSEND = 'moosend',
  CAMPAIGN_MONITOR = 'campaign_monitor',
  ZOHO_CAMPAIGNS = 'zoho_campaigns',
  NETCORE_CLOUD = 'netcore_cloud',
  MAILMODO = 'mailmodo',
  MAILERLITE = 'mailerlite',
  CONSTANT_CONTACT = 'constant_contact',
  OMNISEND = 'omnisend',
  AWEBER = 'aweber',
  AZURE = 'azure',
  GOOGLE_WORKSPACE_SMTP = 'google_workspace_smtp',
}

export enum EspType {
  // Transactional / SMTP / API Email Relays
  SENDGRID = 'sendgrid',
  POSTMARK = 'postmark',
  AMAZON_SES = 'amazon_ses',
  MAILGUN = 'mailgun',
  SPARKPOST = 'sparkpost',
  SMTP2GO = 'smtp2go',
  SMTP_COM = 'smtp_com',
  SOCKETLABS = 'socketlabs',
  ELASTIC_EMAIL = 'elastic_email',
  PEPIPOST = 'pepipost',
  MAILJET = 'mailjet',
  BREVO = 'brevo',
  ZEPTOMAIL = 'zeptomail',
  MAILERSEND = 'mailersend',
  MANDRILL = 'mandrill',
  MAILCHANNELS = 'mailchannels',
  INBOXROAD = 'inboxroad',
  IDEALSMTP = 'idealsmtp',
  SENDLAYER = 'sendlayer',
  SENDPULSE = 'sendpulse',
  EMAILSUCCESS = 'emailsuccess',
  SMTPMART = 'smtpmart',
  TURBOSMTP = 'turbosmtp',
  AUTHSMTP = 'authsmtp',
  DUOCIRCLE = 'duocircle',
  POWERMTA = 'powermta',
  GREENARROW = 'greenarrow',
  POSTAL = 'postal',
  MAILTRAP = 'mailtrap',
  SENDFAST = 'sendfast',
  CAMPAIGNER_SMTP = 'campaigner_smtp',
  // Marketing / Bulk Email ESPs
  MAILCHIMP = 'mailchimp',
  KLAVIYO = 'klaviyo',
  AWEBER = 'aweber',
  GETRESPONSE = 'getresponse',
  ACTIVE_CAMPAIGN = 'active_campaign',
  CAMPAIGN_MONITOR = 'campaign_monitor',
  CONSTANT_CONTACT = 'constant_contact',
  MAILERLITE = 'mailerlite',
  OMNISEND = 'omnisend',
  DRIP = 'drip',
  MOOSEND = 'moosend',
  BENCHMARK_EMAIL = 'benchmark_email',
  SENDER = 'sender',
  SELZY = 'selzy',
  CONVERTKIT = 'convertkit',
  VERTICAL_RESPONSE = 'vertical_response',
  ZOHO_CAMPAIGNS = 'zoho_campaigns',
  HUBSPOT_EMAIL = 'hubspot_email',
  DOTDIGITAL = 'dotdigital',
  SELLIGENT = 'selligent',
  SHARPSPRING = 'sharpspring',
  // Enterprise / CRM / Customer Engagement Platforms
  SALESFORCE_MARKETING_CLOUD = 'salesforce_marketing_cloud',
  SALESFORCE_ACCOUNT_ENGAGEMENT = 'salesforce_account_engagement',
  ORACLE_RESPONSYS = 'oracle_responsys',
  ORACLE_ELOQUA = 'oracle_eloqua',
  ADOBE_MARKETO = 'adobe_marketo',
  BRAZE = 'braze',
  ITERABLE = 'iterable',
  MOENGAGE = 'moengage',
  CUSTOMER_IO = 'customer_io',
  EMARSYS = 'emarsys',
  SAP_EMARSYS = 'sap_emarsys',
  TWILIO_SEGMENT_EMAIL = 'twilio_segment_email',
  IBM_WATSON_CAMPAIGN_AUTOMATION = 'ibm_watson_campaign_automation',
  // Cloud Provider Email Relays
  MICROSOFT_AZURE_COMMUNICATION_SERVICES = 'microsoft_azure_communication_services',
  ORACLE_CLOUD_EMAIL_DELIVERY = 'oracle_cloud_email_delivery',
  GOOGLE_WORKSPACE_SMTP_RELAY = 'google_workspace_smtp_relay',
  ALIBABA_CLOUD_DIRECTMAIL = 'alibaba_cloud_directmail',
  TENCENT_CLOUD_SES = 'tencent_cloud_ses',
  HUAWEI_CLOUD_EMAIL_SERVICE = 'huawei_cloud_email_service',
  // Security / Gateway / Infra Relays
  MICROSOFT_EXCHANGE_ONLINE = 'microsoft_exchange_online',
  PROOFPOINT = 'proofpoint',
  MIMECAST = 'mimecast',
  BARRACUDA = 'barracuda',
  CISCO_SECURE_EMAIL = 'cisco_secure_email',
  ZIMBRA = 'zimbra',
  ICEWARP = 'icewarp',
  KERIO_CONNECT = 'kerio_connect',
  // Regional / Lesser-Known ESPs
  NETCORE = 'netcore',
  NETEASE_MAIL = 'netease_mail',
  YANDEX = 'yandex',
  MAIL_RU = 'mail_ru',
  TENCENT_EXMAIL = 'tencent_exmail',
  ZOHO_MAIL = 'zoho_mail',
  GMX_MAIL = 'gmx_mail',
  IONOS = 'ionos',
  ARUBA_MAIL = 'aruba_mail',
  OVH_MAIL = 'ovh_mail',
  // General / Other
  FASTMAIL = 'fastmail',
  SMTP = 'smtp',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  AWS_API = 'aws_api',
  AWS_SMTP = 'aws_smtp',
  SENDGRID_SMTP = 'sendgrid_smtp',
  SENDGRID_API = 'sendgrid_api',
  OTHER = 'other',
}

export const espTypeDescription = {
  [AuthProvider.SMTP]: "SMTP - Standard SMTP Server",
  [AuthProvider.GOOGLE]: "Google Workspace",
  [AuthProvider.MICROSOFT]: "Microsoft - Office 365",
  [AuthProvider.AWS_API]: "Amazon SES",
  [AuthProvider.SENDGRID_API]: "SendGrid",
  [AuthProvider.KLAVIYO]: "Klaviyo",
  [AuthProvider.MAILCHIMP]: "Mailchimp",
  [AuthProvider.SHOPIFY_EMAIL]: "Shopify Email",
  [AuthProvider.ACTIVECAMPAIGN]: "ActiveCampaign",
  [AuthProvider.BREVO]: "Brevo (Sendinblue)",
  [AuthProvider.CONVERTKIT]: "ConvertKit",
  [AuthProvider.HUBSPOT]: "HubSpot",
  [AuthProvider.DRIP]: "Drip",
  [AuthProvider.GETRESPONSE]: "GetResponse",
  [AuthProvider.MOOSEND]: "Moosend",
  [AuthProvider.CAMPAIGN_MONITOR]: "Campaign Monitor",
  [AuthProvider.ZOHO_CAMPAIGNS]: "Zoho Campaigns",
  [AuthProvider.NETCORE_CLOUD]: "Netcore Cloud",
  [AuthProvider.MAILMODO]: "Mailmodo",
  [AuthProvider.MAILERLITE]: "MailerLite",
  [AuthProvider.CONSTANT_CONTACT]: "Constant Contact",
  [AuthProvider.OMNISEND]: "Omnisend",
  [AuthProvider.AWEBER]: "AWeber",
  // EspType entries - Transactional / SMTP / API Email Relays
  [EspType.POSTMARK]: "Postmark",
  [EspType.AMAZON_SES]: "Amazon SES",
  [EspType.MAILGUN]: "Mailgun",
  [EspType.SPARKPOST]: "SparkPost",
  [EspType.SMTP2GO]: "SMTP2GO",
  [EspType.SMTP_COM]: "SMTP.com",
  [EspType.SOCKETLABS]: "SocketLabs",
  [EspType.ELASTIC_EMAIL]: "Elastic Email",
  [EspType.PEPIPOST]: "Pepipost",
  [EspType.MAILJET]: "Mailjet",
  [EspType.ZEPTOMAIL]: "ZeptoMail",
  [EspType.MAILERSEND]: "MailerSend",
  [EspType.MANDRILL]: "Mandrill",
  [EspType.MAILCHANNELS]: "MailChannels",
  [EspType.INBOXROAD]: "InboxRoad",
  [EspType.IDEALSMTP]: "IdealSMTP",
  [EspType.SENDLAYER]: "SendLayer",
  [EspType.SENDPULSE]: "SendPulse",
  [EspType.EMAILSUCCESS]: "EmailSuccess",
  [EspType.SMTPMART]: "SMTPMart",
  [EspType.TURBOSMTP]: "TurboSMTP",
  [EspType.AUTHSMTP]: "AuthSMTP",
  [EspType.DUOCIRCLE]: "DuoCircle",
  [EspType.POWERMTA]: "PowerMTA",
  [EspType.GREENARROW]: "GreenArrow",
  [EspType.POSTAL]: "Postal",
  [EspType.MAILTRAP]: "Mailtrap",
  [EspType.SENDFAST]: "SendFast",
  [EspType.CAMPAIGNER_SMTP]: "Campaigner SMTP",
  // Marketing / Bulk Email ESPs
  [EspType.ACTIVE_CAMPAIGN]: "ActiveCampaign",
  [EspType.BENCHMARK_EMAIL]: "Benchmark Email",
  [EspType.SENDER]: "Sender",
  [EspType.SELZY]: "Selzy",
  [EspType.VERTICAL_RESPONSE]: "VerticalResponse",
  [EspType.HUBSPOT_EMAIL]: "HubSpot Email",
  [EspType.DOTDIGITAL]: "dotdigital",
  [EspType.SELLIGENT]: "Selligent",
  [EspType.SHARPSPRING]: "SharpSpring",
  [EspType.SALESFORCE_MARKETING_CLOUD]: "Salesforce Marketing Cloud",
  [EspType.SALESFORCE_ACCOUNT_ENGAGEMENT]: "Salesforce Account Engagement",
  [EspType.ORACLE_RESPONSYS]: "Oracle Responsys",
  [EspType.ORACLE_ELOQUA]: "Oracle Eloqua",
  [EspType.ADOBE_MARKETO]: "Adobe Marketo",
  [EspType.BRAZE]: "Braze",
  [EspType.ITERABLE]: "Iterable",
  [EspType.MOENGAGE]: "MoEngage",
  [EspType.CUSTOMER_IO]: "Customer.io",
  [EspType.EMARSYS]: "Emarsys",
  [EspType.SAP_EMARSYS]: "SAP Emarsys",
  [EspType.TWILIO_SEGMENT_EMAIL]: "Twilio Segment Email",
  [EspType.IBM_WATSON_CAMPAIGN_AUTOMATION]: "IBM Watson Campaign Automation",
  [EspType.MICROSOFT_AZURE_COMMUNICATION_SERVICES]: "Microsoft Azure Communication Services",
  [EspType.ORACLE_CLOUD_EMAIL_DELIVERY]: "Oracle Cloud Email Delivery",
  [EspType.GOOGLE_WORKSPACE_SMTP_RELAY]: "Google Workspace SMTP Relay",
  [EspType.ALIBABA_CLOUD_DIRECTMAIL]: "Alibaba Cloud DirectMail",
  [EspType.TENCENT_CLOUD_SES]: "Tencent Cloud SES",
  [EspType.HUAWEI_CLOUD_EMAIL_SERVICE]: "Huawei Cloud Email Service",
  [EspType.MICROSOFT_EXCHANGE_ONLINE]: "Microsoft Exchange Online",
  [EspType.PROOFPOINT]: "Proofpoint",
  [EspType.MIMECAST]: "Mimecast",
  [EspType.BARRACUDA]: "Barracuda",
  [EspType.CISCO_SECURE_EMAIL]: "Cisco Secure Email",
  [EspType.ZIMBRA]: "Zimbra",
  [EspType.ICEWARP]: "IceWarp",
  [EspType.KERIO_CONNECT]: "Kerio Connect",
  [EspType.NETCORE]: "Netcore",
  [EspType.NETEASE_MAIL]: "NetEase Mail",
  [EspType.YANDEX]: "Yandex",
  [EspType.MAIL_RU]: "Mail.ru",
  [EspType.TENCENT_EXMAIL]: "Tencent Exmail",
  [EspType.ZOHO_MAIL]: "Zoho Mail",
  [EspType.GMX_MAIL]: "GMX Mail",
  [EspType.IONOS]: "IONOS",
  [EspType.ARUBA_MAIL]: "Aruba Mail",
  [EspType.OVH_MAIL]: "OVH Mail",
  [EspType.FASTMAIL]: "Fastmail",
  [EspType.AWS_SMTP]: "AWS SMTP",
  [EspType.SENDGRID_SMTP]: "SendGrid SMTP",
  [EspType.SENDGRID_API]: "SendGrid API",
  [EspType.OTHER]: "Other",
}